// Purposefully ES5/CommonJS for now.

var trueRegExp = /^(?:true|1)$/i;

function parseTrue(s) {
  return trueRegExp.test(s);
}

module.exports = {
  parseTrue: parseTrue
};



// WEBPACK FOOTER //
// ./src/utils/parseBool.js